import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../common/Card';
import Table from '../common/Table';
import Button from '../common/Button';
import api from '../../services/api';
import { formatCurrency } from '../../utils/formatters';
import '../../styles/low-stock.css';

const LowStockAlert = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLowStockProducts();
  }, []);

  const loadLowStockProducts = async () => {
    setLoading(true);
    try {
      const response = await api.get('/inventory.php/low-stock');
      setProducts(response.data.low_stock);
    } catch (error) {
      console.error('Failed to load low stock products:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRestock = (product) => {
    navigate(`/products/stock/${product.id}`, { 
      state: { product, action: 'receive' }
    });
  };

  const columns = [
    {
      key: 'product_name',
      label: 'Product'
    },
    {
      key: 'sku',
      label: 'SKU'
    },
    {
      key: 'current_stock',
      label: 'Current Stock',
      render: (value, row) => (
        <span className="stock-value">{value} {row.unit}</span>
      )
    },
    {
      key: 'min_stock_level',
      label: 'Min Stock Level',
      render: (value, row) => (
        <span className="min-stock">{value} {row.unit}</span>
      )
    },
    {
      key: 'shortage',
      label: 'Shortage',
      render: (value, row) => (
        <span className="shortage">{row.min_stock_level - row.current_stock} {row.unit}</span>
      )
    },
    {
      key: 'selling_price',
      label: 'Price',
      render: (value) => formatCurrency(value)
    },
    {
      key: 'actions',
      label: 'Actions',
      render: (_, row) => (
        <Button size="sm" onClick={() => handleRestock(row)}>
          Restock
        </Button>
      )
    }
  ];

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="low-stock">
      <Card>
        <div className="low-stock-header">
          <h2>Low Stock Alert</h2>
          <Button variant="primary" onClick={loadLowStockProducts} icon="🔄">
            Refresh
          </Button>
        </div>

        {products.length === 0 ? (
          <div className="no-alerts">
            <div className="success-icon">✅</div>
            <h3>All Good!</h3>
            <p>No products are running low on stock.</p>
          </div>
        ) : (
          <>
            <div className="alert-summary">
              <p className="alert-count">
                ⚠️ {products.length} product{products.length > 1 ? 's' : ''} need attention
              </p>
            </div>

            <Table
              columns={columns}
              data={products}
              onRowClick={(row) => navigate(`/products/${row.id}`)}
            />

            <div className="bulk-actions">
              <Button variant="primary" icon="📦">
                Generate Purchase Order
              </Button>
              <Button variant="secondary" icon="📊">
                View Report
              </Button>
            </div>
          </>
        )}
      </Card>
    </div>
  );
};

export default LowStockAlert;